module.exports = __webpack_public_path__ + "img/creditcardcorporate.e3302cee.svg";